var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"area_right1"}},[_c('div',{staticClass:"cc-header"},[_vm._v("教师请假分析 "),_c('div',{staticClass:"view_btn",on:{"click":_vm.showTable}},[_vm._v("请假明细")])]),_c('div',{staticClass:"main-value",attrs:{"id":"tea_leave"}})])}
var staticRenderFns = []

export { render, staticRenderFns }